"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var context_1 = __importDefault(require("./context"));

var track_1 = __importDefault(require("../track/track"));

var __1 = require("../..");

var PlayHistory = function () {
  function PlayHistory(json) {
    this.track = new track_1.default(json.track);
    this.playedAt = json.played_at;
    this.context = json.context ? new context_1.default(json.context) : null;
  }

  PlayHistory.prototype.getContextData = function () {
    if (this.context) {
      var _a = this.context.uri.split(':'),
          type = _a[1],
          id = _a[2];

      switch (type) {
        case 'album':
          return __1.getAlbum(id);

        case 'artist':
          return __1.getArtist(id);

        case 'playlist':
          return __1.getPlaylist(id);

        default:
          return __1.getAlbum(this.track.album.id);
      }
    }

    return __1.getAlbum(this.track.album.id);
  };

  return PlayHistory;
}();

exports.default = PlayHistory;